import axios from 'axios';

const DocumentService = {
  async createDocument({ formValues, loanId, lenderId }) {
    const response = await axios.post('/document', {
      ...formValues,
      loan_id: loanId,
      lender_id: lenderId,
      mime_type: 'application/pdf',
      category: 'user',
    });

    return response.data;
  },

  async getDocument(documentId) {
    const response = await axios.get(`/document/${documentId}`);

    return response.data;
  },

  async getLoanDocuments({ loanId, category, status }) {
    const response = await axios.get(`/loan/${loanId}/document`, {
      params: {
        category,
        status,
      },
    });

    return response.data;
  },

  async getLoanDocumentsForLender(loanId) {
    const response = await axios.get(`/loan/${loanId}/documents`);

    return response.data;
  },

  async getLoanStatements(loanId) {
    const response = await axios.get(`/document/statements/${loanId}`);

    return response.data;
  },

  async getLenderDocuments({ lenderId, category, status }) {
    const response = await axios.get(`/lender/${lenderId}/document`, {
      params: {
        category,
        status,
      },
    });

    return response.data;
  },

  async updateDocument({ documentId, formValues }) {
    const response = await axios.put(`/document/${documentId}`, formValues);

    return response.data;
  },

  async parseDocument(documentId) {
    const response = await axios.patch(`/document/${documentId}/parseur`, {
      mailbox: 'NOTE',
    });

    return response.data;
  },

  async generateLoan({ documentId, lenderId }) {
    const response = await axios.post(`/document/${documentId}/generate_loan`, {
      lender_id: lenderId,
    });

    return response.data;
  },
};

export default DocumentService;
